//import axios from "axios";
import ApiService from "@/core/services/api.service";
// action types
export const OBTENER_REGIONES = "obtenerRegiones";
export const OBTENER_REGION = "obtenerRegion";
export const ACTUALIZAR_REGION = "actualizarRegion";
export const REGISTRAR_REGION = "registrarRegion";
// mutation types
export const SET_REGIONES = "setRegiones";
export const SET_REGION = "setRegion";

const state = {
    regiones: [],
    region:[],
}

const getters = {
    obtenerRegiones(state) {
      return state.regiones;
    },
}

const actions = {
    /**
     * Obtener Regiones (todos o por estado (activo, incativo, etc))
     * @param {} context 
     * @param {*} estadoId 
     * @returns 
     */
    async [OBTENER_REGIONES](context, estadoId) {

        let endpoint = 'api/Regiones'
        if(estadoId>0){
            endpoint = `api/Regiones/Estado/${estadoId}`
        }

        return new Promise(resolve => {
            ApiService.query(`apiconsume/obtener?endpoint=${endpoint}`, '')
                .then(({ data }) => {
                    context.commit(SET_REGIONES, data.data);
                    //console.log(data)
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)

                    //context.commit(SET_ERROR, response.data.errors);
                });
        });       
    },

    

    async [OBTENER_REGION](context, id){
        
        return new Promise(resolve => {
            ApiService.query(`apiconsume/edit/${id}?endpoint=api/Regiones/`)
                .then(({ data }) => {
                    context.commit(SET_REGION, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });    


    },
    async [REGISTRAR_REGION](context, datosRegion){
        return new Promise(resolve => {
            ApiService.post(`apiconsume/create?endpoint=api/Regiones`, datosRegion)
                .then(({ data }) => {
                    context.commit(SET_REGION, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });   
    },
    async [ACTUALIZAR_REGION](context, datosRegion){
        let id = datosRegion.id;
        
        return new Promise(resolve => {
            ApiService.post(`apiconsume/update/${id}?endpoint=api/Regiones/`, datosRegion)
                .then(({ data }) => {
                    context.commit(SET_REGION, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });    
    }
  }

const mutations = {
    [SET_REGIONES](state, data) {
        state.regiones = data;
    },

    [SET_REGION](state, data) {
        state.region = data;
    }
}


export default {
    state,
    getters,
    actions,
    mutations
}